import { nanoid } from 'nanoid'

export const SEGMENTS_SMALL_TOWN_HAMLET_OR_VILLAGE_COMMERCIAL = {
  DEFAULT_BUILDING_HEIGHT_LEFT: 1,
  DEFAULT_BUILDING_HEIGHT_RIGHT: 1,
  DEFAULT_BUILDING_VARIANT_LEFT: 'narrow',
  DEFAULT_BUILDING_VARIANT_RIGHT: 'wide',
  segments: [
    {
      type: 'sidewalk',
      variant: { 'sidewalk-density': 'empty' },
      width: 6,
      id: nanoid()
    },

    {
      type: 'divider',
      variant: { 'divider-type': 'planting-strip' },
      width: 14,
      id: nanoid()
    },
    {
      type: 'parking-lane',
      variant: {
        direction: 'inbound|left'
      },
      width: 7,
      id: nanoid()
    },
    {
      type: 'drive-lane',
      variant: {
        direction: 'inbound',
        'car-type': 'car'
      },
      width: 10,
      id: nanoid()
    },
    {
      type: 'drive-lane',
      variant: {
        direction: 'inbound',
        'car-type': 'car'
      },
      width: 11,
      id: nanoid()
    },

    {
      type: 'drive-lane',
      variant: {
        direction: 'outbound',
        'car-type': 'car'
      },
      width: 10,
      id: nanoid()
    },
    {
      type: 'drive-lane',
      variant: {
        direction: 'outbound',
        'car-type': 'car'
      },
      width: 11,
      id: nanoid()
    },

    {
      type: 'parking-lane',
      variant: {
        direction: 'inbound|right'
      },
      width: 7,
      id: nanoid()
    },
    {
      type: 'sidewalk',
      variant: { sidewalk: 'empty' },
      width: 6,
      id: nanoid()
    },
    {
      type: 'sidewalk-tree',
      variant: { 'tree-type': 'big' },
      width: 5,
      id: nanoid()
    },
    // { type: 'sidewalk-tree', variant: { 'tree-type': 'big' }, width: 2 },
    {
      type: 'sidewalk',
      variant: { 'sidewalk-density': 'dense' },
      width: 9,
      id: nanoid()
    }
  ]
}
